import React, { useCallback, useContext, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import { searchLensesSelector } from 'store/reducers/user-reducer';

import ContactCTA from '../../ContactCTA';
import DataTypeLen from '../../DataTypeLen';
import { HomeDrawerContext } from '../HomeDrawerContext';
import {
  HomeBaseDrawerBottomDataTypeLensesWrapper,
  HomeBaseDrawerBottomWrapper,
  HomeBaseDrawerContainer,
  HomeBaseDrawerContentContainer,
  HomeBaseDrawerTopWrapper,
  HomeBaseDrawerWrapper,
} from './styled';

interface HomeBaseDrawerProps {
  children?: React.ReactNode;
  top?: React.ReactNode;
  CTADescription?: string;
}

export default function HomeBaseDrawer({ children, top, CTADescription }: HomeBaseDrawerProps) {
  const searchLensCollectiveDirectoryCTAClickedBehavioral = useBehavioral(
    BEHAVIORALS.SEARCH_LENS_COLLECTIVE_DIRECTORY_CTA_CLICKED
  );
  const context = useContext(HomeDrawerContext);
  const [contentPadding, setContentPadding] = useState({ top: 0, bottom: 156 });

  const topWrapperRef = useCallback((node: HTMLDivElement) => {
    if (node) {
      const observer = new ResizeObserver((entries) => {
        const { height } = entries[0].target.getBoundingClientRect();
        setContentPadding((prev) => ({ ...prev, top: height }));
      });

      observer.observe(node);
    }
  }, []);

  const handleContactCTABehavioralFunction = () => {
    searchLensCollectiveDirectoryCTAClickedBehavioral({
      action_details: context.model,
    });
  };

  return (
    <HomeBaseDrawerWrapper>
      <HomeBaseDrawerContainer>
        {top ? (
          <HomeBaseDrawerTopWrapper ref={topWrapperRef}>
            <HomeBaseDrawerBottom />
            {top}
          </HomeBaseDrawerTopWrapper>
        ) : null}
        <HomeBaseDrawerContentContainer paddingTop={contentPadding.top}>
          {children}
        </HomeBaseDrawerContentContainer>
        <HomeBaseDrawerBottomWrapper>
          <ContactCTA
            description={CTADescription}
            behavioralFunction={handleContactCTABehavioralFunction}
          />
        </HomeBaseDrawerBottomWrapper>
      </HomeBaseDrawerContainer>
    </HomeBaseDrawerWrapper>
  );
}

export function HomeBaseDrawerBottom() {
  const { model, setModel } = useContext(HomeDrawerContext);
  const searchLenses: any = useSelector(searchLensesSelector);

  const pills = useMemo(() => {
    return {
      people: searchLenses?.people,
      passions: searchLenses?.passions,
      skills: searchLenses?.skills,
      companies: searchLenses?.members + searchLenses?.partners,
      clients: searchLenses?.clients,
      industries: searchLenses?.industries,
      disciplines: searchLenses?.disciplines || 0,
    };
  }, []);

  const handleDataTypeLenClick = (key: string) => {
    setModel(key as any);
  };

  return (
    <HomeBaseDrawerBottomDataTypeLensesWrapper currentModel={model} data-type="lenses">
      {Object.keys(pills).map(
        (
          key:
            | 'people'
            | 'passions'
            | 'skills'
            | 'companies'
            | 'clients'
            | 'industries'
            | 'disciplines'
        ) => (
          <DataTypeLen
            type={key}
            counter={pills[key]}
            mode={'compact'}
            key={key}
            onClick={() => handleDataTypeLenClick(key)}
          />
        )
      )}
    </HomeBaseDrawerBottomDataTypeLensesWrapper>
  );
}
